import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { FormErrorsComponent } from '../form-errors/form-errors.component';
import { TextInputComponent } from '../input/text-input.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LimitHintComponent } from '../limit-hint/limit-hint.component';

@Component({
  selector: 'boels-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    FormErrorsComponent,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
    FontAwesomeModule,
    NgbTooltipModule,
    LimitHintComponent,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true,
    },
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['form'],
    },
  ],
})
export class TextareaComponent extends TextInputComponent {
  @Input()
  rows = '4';
  @Input()
  cols = '50';
  @Input()
  showDivider = false;
}
